module.exports = __webpack_public_path__ + "static/DetectiveGui1-a497c6015a0aed8fb7f525e1ed877232.webp";